import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Role} from '../../../data/models/role';
import {RoleService} from '../../../services/api/role.service';
import {UserService} from '../../../services/api/user.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '../../../data/models/user';
import {USER_VALIDATORS} from '../../../../constants/validators';
import {UserValidators} from '../../../validators/user-validators';

@Component({
  selector: 'app-user-edit-dialog',
  templateUrl: './user-edit-dialog.component.html',
  styleUrls: ['./user-edit-dialog.component.css']
})
export class UserEditDialogComponent implements OnInit {

  public user: User;
  public userForm: FormGroup;
  public roles: Role[] = [];

  constructor(
    private roleService: RoleService,
    private userService: UserService,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      user: User,
    },
  ) {
    this.user = this.data.user;
    this.userForm = this.fb.group({
      mail: [this.user.mail, USER_VALIDATORS.MAIL, [UserValidators.uniqueMailValidator(this.userService, this.user.id)]],
      surname: [this.user.surname, USER_VALIDATORS.SURNAME],
      name: [this.user.name, USER_VALIDATORS.NAME],
      patronymic: [this.user.patronymic, USER_VALIDATORS.PATRONYMIC],
      roles: [this.user.roles.map(r => r.id)],
    });
  }

  ngOnInit(): void {
    this.getRoles();
  }

  getRoles(): void {
    this.roleService.roles$
      .subscribe(roles => this.roles = roles);
  }

  onSubmit(event: MouseEvent): void {
    event.preventDefault();
    if (this.userForm.valid) {
      this.userService.updateUser(this.user.id, {
        mail: this.userForm.controls.mail.value,
        surname: this.userForm.controls.surname.value,
        name: this.userForm.controls.name.value,
        patronymic: this.userForm.controls.patronymic.value,
        roles: this.userForm.controls.roles.value,
      })
        .then(user => this.dialogRef.close(user))
        .catch(error => {
        });
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
